export default __webpack_public_path__ + "website-icon.svg";